var _a;
import { __decorate, __metadata } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { Logger } from '@patsnap/tahiti-core/common/logger';
let CurrentSpaceServiceImpl = class CurrentSpaceServiceImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = undefined;
    }
    getCurrentSpace() {
        return this.modelData;
    }
    setCurrentSpace(space) {
        this.update(() => {
            return space;
        });
        this._logger.info('Current space set to:', space);
    }
    dispose() {
        this.update(() => null);
    }
};
__decorate([
    inject(Logger),
    __metadata("design:type", typeof (_a = typeof Logger !== "undefined" && Logger) === "function" ? _a : Object)
], CurrentSpaceServiceImpl.prototype, "_logger", void 0);
CurrentSpaceServiceImpl = __decorate([
    injectable()
], CurrentSpaceServiceImpl);
export { CurrentSpaceServiceImpl };
